import Project from "../project";
import delete_project from "../../../gd-ui/more/project/actions/delete-project"

export default class ProjectActions {

    public project: Project

    constructor(project:Project) {
        this.project = project
    }

    convert = (callback:any) => {
        gd.modals.project.convert(this, this.project.id, (result:any)=>{
            // we already sent request in modal... po idee konechno nado bilo tut eto delat'
            // update model
            this.project.localTemplateId = result.localTemplateId;

            // OLD - i think it's a typoe
            // this.ownerUserId = result.owner;
            this.project.ownerUserId = result.owner;

            if (callback) callback(result);
        });
    }


    move = (callback:callback) => {
        gd.modals.project.move(this, this.project.id, ()=>{
            if (callback) callback();
        });
    }

    duplicate = (callback:callback) => {
        gd.modals.project.duplicate(this.project, ()=>{},{});
    }

    delete = () => {
        delete_project(this.project.id)
    }

    saveAsTemplate = () => {

        // this is Pro feature
        if (!gd.company.license.isPro) {
            gd.modals.other.upgradeToPro();
            return
        }

        gd.modals.project.saveAsTemplate(this.project, null);
    }

}